<section class="account-setup" aria-live="polite">
  <h2 class="account-setup__title">{{ translate("accountSetup.title") }}</h2>
  <p class="account-setup__intro">
    {{ translate(mode === "create" ? "accountSetup.intro.create" : "accountSetup.intro.update") }}
  </p>

  <form class="account-setup__form" [formGroup]="form" (ngSubmit)="submit()" novalidate>
    <mat-form-field appearance="outline" class="account-setup__field">
      <mat-label>{{ translate("accountSetup.fields.salutation") }}</mat-label>
      <mat-select formControlName="salutation">
        @for (option of salutationOptions; track option.value) {
          <mat-option [value]="option.value">{{ translate(option.translationKey) }}</mat-option>
        }
      </mat-select>
      @if (controlHasError("salutation", "required")) {
        <mat-error>
          {{ translate("accountSetup.errors.salutationRequired") }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="account-setup__field">
      <mat-label>{{ translate("accountSetup.fields.firstName") }}</mat-label>
      <input matInput type="text" formControlName="firstName" autocomplete="given-name" />
      @if (controlHasError("firstName", "required")) {
        <mat-error>
          {{ translate("accountSetup.errors.firstNameRequired") }}
        </mat-error>
      }
      @if (controlHasError("firstName", "maxlength")) {
        <mat-error>
          {{ translate("accountSetup.errors.firstNameTooLong") }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="account-setup__field">
      <mat-label>{{ translate("accountSetup.fields.lastName") }}</mat-label>
      <input matInput type="text" formControlName="lastName" autocomplete="family-name" />
      @if (controlHasError("lastName", "required")) {
        <mat-error>
          {{ translate("accountSetup.errors.lastNameRequired") }}
        </mat-error>
      }
      @if (controlHasError("lastName", "maxlength")) {
        <mat-error>
          {{ translate("accountSetup.errors.lastNameTooLong") }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="account-setup__field">
      <mat-label>{{ translate("accountSetup.fields.username") }}</mat-label>
      <input matInput type="text" formControlName="username" autocomplete="username" />
      @if (controlHasError("username", "required")) {
        <mat-error>
          {{ translate("accountSetup.errors.usernameRequired") }}
        </mat-error>
      }
      @if (controlHasError("username", "pattern")) {
        <mat-error>
          {{ translate("accountSetup.errors.usernameInvalid") }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="account-setup__field">
      <mat-label>{{ translate("accountSetup.fields.language") }}</mat-label>
      <mat-select formControlName="language">
        <mat-option [value]="null">{{ translate("accountSetup.language.auto") }}</mat-option>
        @for (language of languageList; track language) {
          <mat-option [value]="language">{{ getLanguageLabel(language) }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (errorMessage()) {
      <p class="account-setup__error">{{ errorMessage() }}</p>
    }

    <button mat-raised-button color="primary" type="submit" [disabled]="disableSubmit()">
      @if (submitting()) {
        <mat-progress-spinner diameter="18" mode="indeterminate" class="account-setup__spinner"></mat-progress-spinner>
      }
      <span>
        {{ translate(mode === "create" ? "accountSetup.actions.create" : "accountSetup.actions.save") }}
      </span>
    </button>
  </form>
</section>
